import graphql__df59b2dbc050822c20a3 from "./__generated__/MapClusterizedPointMarkers_map.graphql.js";import { graphql, useFragment } from "react-relay";

import MarkerClusterGroup from "../MarkerClusterGroup";
import { createMapMarkerClusterIcon } from "../createMapMarkerClusterIcon";
import MapClusterizedPointMarker from "./MapClusterizedPointMarker";
import { useMapElementsFilteredIn } from "./useMapElementsFilteredIn";

const MapClusterizedPointMarkers = props => {
  const map = useFragment(MapClusterizedPointMarkers_map, props.map);
  const { onPointClick } = props;

  const pointsWithFilterState = useMapElementsFilteredIn({
    map,
    elements: map.clusterizedPoints
  });
  const displayedPoints = pointsWithFilterState.filter(({ isFilteredIn }) => {
    return isFilteredIn;
  });

  if (!displayedPoints.length) return null;

  // Leaflet MarkerCluster caches its children, so remount it when filtering changes the
  // displayed points to ensure removed markers do not remain in an existing cluster.
  const clusterGroupKey = displayedPoints.map(({ id }) => id).join(":");

  return (
    <MarkerClusterGroup
      key={clusterGroupKey}
      showCoverageOnHover={false}
      maxClusterRadius={map.markersMaxClusterRadius}
      iconCreateFunction={createMapMarkerClusterIcon}
    >
      {displayedPoints.map(point => (
        <MapClusterizedPointMarker key={point.id} point={point} onClick={onPointClick} />
      ))}
    </MarkerClusterGroup>
  );
};

const MapClusterizedPointMarkers_map = graphql__df59b2dbc050822c20a3;

export default MapClusterizedPointMarkers;
